import { useMemo } from 'react'

import { useQuery } from 'react-query'

import { Tax } from '@webapp/platform/finance/entities/Tax'
import { taxQueryConfig } from '@webapp/platform/finance/query-configs/tax'

export const useTaxSelect = ({ defaultTaxId }: { defaultTaxId?: number }) => {
  const { data, isFetching } = useQuery({
    ...taxQueryConfig.getTaxesSelect(),
    cacheTime: Infinity,
  })

  const taxes = useMemo(() => data?.data.map((t) => new Tax(t)) || [], [data])

  const defaultValue = useMemo(
    () => data?.data.find((t) => t.id === defaultTaxId) || null,
    [data, defaultTaxId]
  )

  return {
    data: { defaultValue, taxes },
    states: { isFetching },
  }
}
